import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react'
import logo from '../assets/logo.js'

const Footer = () => (
  <footer className="Footer_footer__G3ZMq">
    <div className="container Footer_footerGrid__bF7AP">
      <div className="Footer_brandCol__EDsRP">
        <Link to="/" className="Footer_logo__dGQmj">
          <span className="Footer_logoMark__n-6tb">
            <img src={logo} alt="" aria-hidden="true" />
          </span>
          <span>Vitae Careers</span>
        </Link>
        <p className="Footer_tagline__JJZcQ">"Timely Acquired Career Guidance Gives Success."</p>
        <p className="Footer_desc__+jM+S">We, Vitae Career Enterprises cater career counselling services mainly in Lucknow and Balrampur (UP) to help school and college going students and professionals in deciding their career. We believe in - "Timely Acquired Career Guidance Gives Success."</p>
        <div className="Footer_serviceAreas__fnFuz">
          <span>Lucknow</span>
          <span>Balrampur</span>
          <span>Online</span>
        </div>
      </div>
      <div className="Footer_linksCol">
        <h4 className="Footer_colTitle__Rf8lZ">Quick Links</h4>
        <ul className="Footer_linkList__U6Ccc">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/how-it-works">Why It Matters</Link></li>
          <li><Link to="/services">Career Assessment</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/blog">Blog</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
        </ul>
      </div>
      <div className="Footer_contactCol">
        <h4 className="Footer_colTitle__Rf8lZ">Contact Us</h4>
        <ul className="Footer_contactList__S+CEW">
          <li>
            <Phone size={18} className="Footer_icon__KTUwy" />
            <a href="tel:+919335879877">+91 9335879877</a>
          </li>
          <li>
            <Mail size={18} className="Footer_icon__KTUwy" />
            <a href="mailto:careervitae2025@gmail.com">careervitae2025@gmail.com</a>
          </li>
          <li>
            <MapPin size={18} className="Footer_icon__KTUwy" />
            <span>C-703, Tower-C, The Grace, Sector-B, Sushant Golf City, Lucknow-226030</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="Footer_bottomBar__zxKhF">
      <div className="container Footer_bottomContent__abB31">
        <p className="Footer_copyright__qN4FT">&copy; 2025 VitaeCareers</p>
        <div className="Footer_socials__XW6cN">
          <a href="https://www.facebook.com/profile.php?id=61576837301032" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <Facebook size={20} />
          </a>
          <a href="https://x.com/VitaeCareers" target="_blank" rel="noopener noreferrer" aria-label="Twitter / X">
            <Twitter size={20} />
          </a>
          <a href="https://www.instagram.com/careercounseloran?igsh=bmxlbjBub2JhY25s" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <Instagram size={20} />
          </a>
          <a href="https://www.linkedin.com/in/cca-a-n-sharma-831787323/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <Linkedin size={20} />
          </a>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
